import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { postAtualizarVisualizadoSic, postRecurso } from '../../api/endpoints';
import { selecionarArquivo } from '../../app/slices/arquivosSlice';
import { selectLogin } from '../../app/slices/loginSlice';
import { abrirModalArquivo, abrirModalImpressaoSic } from '../../app/slices/modalSlice';
import AudioPng from '../../assets/icons/audio.png';
import PdfPng from '../../assets/icons/pdf.png';
import ZipPng from '../../assets/icons/zip.png';
import RarPng from '../../assets/icons/rar.png';
import VideoPng from '../../assets/icons/video.png';
import { Divisor } from '../../styles/base';
import { replaceTags } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import FormControl from '../FormControl/FormControl';
import GridBotao from '../GridBotao/GridBotao';
import Carregar from '../Carregar/Carregar';
import { getTotem } from '../../api/apiFactory';
import {
  BoldTitulo,
  ContainerJustifyEnd,
  GridArquivos, GridContainerPrincipal, LinhaItemSic, LinhaItemSicImpressao, LinhaItemSicSecretaria,
  LinhaItemSicSpaceBetween,
} from './CardSicEstilo';

const defaultValues = {
  Recurso: '',
  IdSic: '',
};

const CardSic = ({
  arquivos, id, assunto, unidade, dataHora, secretaria, pergunta, resposta, frequentes, dataHoraResposta, recurso, respostaRecurso, dataHoraRespostaRecurso, onRefresh, dataHoraAberturaRecurso, retificacao, dataHoraRetificacao, visivelRetificacao, recursoRetificacao, dataHoraAberturaRecursoRetificacao, dataHoraRespostaRecursoRetificacao, respostaRecursoRetificacao,
}) => {
  const [values, setValues] = useState(defaultValues);
  const [carregando, setCarregando] = useState(false);

  const dadosLogin = useSelector(selectLogin);

  const dispatch = useDispatch();
  const alert = useAlert();

  const verificarTempoRecursoResposta = () => {
    const separaDataHoraResposta = dataHoraResposta.split(' ');
    const pegaDataResposta = separaDataHoraResposta[0].split('/');
    const formataData = `${pegaDataResposta[1]}/${pegaDataResposta[0]}/${pegaDataResposta[2]}`;
    const novaDataFormatada = new Date(formataData);
    const pegaDataAtual = new Date();
    const dias = (pegaDataAtual.getTime() - novaDataFormatada.getTime()) / (1000 * 3600 * 24);

    if (dias > 10) return false;

    return true;
  };

  // const verificarTempoRecursoSemResposta = () => {
  //   const separaDataHora = dataHora.split(' ');
  //   const pegaDataHora = separaDataHora[0].split('/');
  //   const formataDataHora = `${pegaDataHora[1]}/${pegaDataHora[0]}/${pegaDataHora[2]}`;
  //   const novaDataFormatada = new Date(formataDataHora);
  //   const pegaDataAtual = new Date();
  //   const dias = (pegaDataAtual.getTime() - novaDataFormatada.getTime()) / (1000 * 3600 * 24);

  //   if (dias > 20) return true;

  //   return false;
  // };

  const verificarTempoRecursoRetificacao = () => {
    const separaDataHora = dataHoraRetificacao.split(' ');
    const pegaDataHora = separaDataHora[0].split('/');
    const formataDataHora = `${pegaDataHora[1]}/${pegaDataHora[0]}/${pegaDataHora[2]}`;

    const novaDataFormatada = new Date(formataDataHora);
    const pegaDataAtual = new Date();
    const dias = (pegaDataAtual.getTime() - novaDataFormatada.getTime()) / (1000 * 3600 * 24);

    if (dias > 10) return false;

    return true;
  };

  const enviarRecurso = async (tipo) => {
    setCarregando(true);

    const resp = await postRecurso({
      ...values,
      IdSic: id,
      tipo,
    });

    if (resp.Error) {
      setCarregando(false);
      return alert.error(
        'Por favor, preencher o campo recurso.', { timeout: 5000 },
      );
    }

    setCarregando(false);
    onRefresh(id);

    return alert.success(resp.Message, { timeout: 5000 });
  };

  useEffect(() => {
    if (resposta) {
      postAtualizarVisualizadoSic(id);
    }
  }, []);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  if (carregando) {
    return (
      <Carregar />
    );
  }

  return (
    <GridContainerPrincipal className="controle-fundo">
      <LinhaItemSicSecretaria>
        {id && (
          <LinhaItemSic>
            <b>Protocolo:</b>
            <span>{id}</span>
          </LinhaItemSic>
        )}
        {(getTotem() !== 'true') && (
          <LinhaItemSicImpressao>
            <Botao
              impressao
              onClick={() => dispatch(abrirModalImpressaoSic({
                arquivos,
                id,
                assunto,
                dataHora,
                secretaria,
                pergunta,
                resposta,
                frequentes,
                dataHoraResposta,
                recurso,
                respostaRecurso,
                dataHoraRespostaRecurso,
                dataHoraAberturaRecurso,
                retificacao,
                dataHoraRetificacao,
                recursoRetificacao,
                dataHoraAberturaRecursoRetificacao,
                dataHoraRespostaRecursoRetificacao,
                respostaRecursoRetificacao,
              }))}
              label="Ir para impressão"
            />
          </LinhaItemSicImpressao>
        )}
      </LinhaItemSicSecretaria>

      <Divisor size="ultraPequeno" />

      {secretaria && (
        <>
          <LinhaItemSic>
            <b>Secretaria:</b>
            <span>{secretaria}</span>
          </LinhaItemSic>

          <Divisor size="ultraPequeno" />
        </>
      )}

      {assunto && (
        <>
          <LinhaItemSic>
            <b>Assunto:</b>
            <span>{assunto}</span>
          </LinhaItemSic>

          <Divisor size="ultraPequeno" />
        </>
      )}

      {unidade && (
        <>
          <LinhaItemSic>
            <b>Unidade:</b>
            <span>{unidade}</span>
          </LinhaItemSic>

          <Divisor size="ultraPequeno" />
        </>
      )}

      <hr />

      <LinhaItemSic>
        <b>Pergunta:</b>
        <span>{replaceTags(pergunta)}</span>
      </LinhaItemSic>

      {resposta && (!retificacao || visivelRetificacao !== 'S') && (
        <>
          <hr />

          <LinhaItemSic>
            <LinhaItemSicSpaceBetween>
              <b>Resposta:</b>
              <small>
                (Respondido em:
                {' '}
                {dataHoraResposta}
                )
              </small>
            </LinhaItemSicSpaceBetween>
            <div dangerouslySetInnerHTML={{ __html: resposta }} />
          </LinhaItemSic>
        </>
      )}

      {retificacao && visivelRetificacao !== 'N' && (
        <>
          <hr />

          <LinhaItemSic>
            <LinhaItemSicSpaceBetween>
              <b>Retificação:</b>
              <small>
                (Retificado em:
                {' '}
                {dataHoraRetificacao}
                )
              </small>
            </LinhaItemSicSpaceBetween>
            <div dangerouslySetInnerHTML={{ __html: retificacao }} />
          </LinhaItemSic>
        </>
      )}

      {recurso && dadosLogin.data.anonimo === 'naoanonimo' && (
        <>
          <hr />

          <LinhaItemSic>
            <LinhaItemSicSpaceBetween>
              <b>Recurso:</b>
              <small>
                (Aberto em:
                {' '}
                {dataHoraAberturaRecurso}
                )
              </small>
            </LinhaItemSicSpaceBetween>
            <div dangerouslySetInnerHTML={{ __html: recurso }} />
          </LinhaItemSic>
        </>
      )}

      {respostaRecurso && dadosLogin.data.anonimo === 'naoanonimo' && (
        <>
          <hr />

          <LinhaItemSic>
            <LinhaItemSicSpaceBetween>
              <b>Resposta do Recurso:</b>
              <small>
                (Respondido em:
                {' '}
                {dataHoraRespostaRecurso}
                )
              </small>
            </LinhaItemSicSpaceBetween>
            <div dangerouslySetInnerHTML={{ __html: respostaRecurso }} />
          </LinhaItemSic>
        </>
      )}

      {recursoRetificacao && (
        <>
          <hr />

          <LinhaItemSic>
            <LinhaItemSicSpaceBetween>
              <b>Recurso da Retificação:</b>
              <small>
                (Aberto em:
                {' '}
                {dataHoraAberturaRecursoRetificacao}
                )
              </small>
            </LinhaItemSicSpaceBetween>
            <div dangerouslySetInnerHTML={{ __html: recursoRetificacao }} />
          </LinhaItemSic>
        </>
      )}

      {respostaRecursoRetificacao && (
        <>
          <hr />

          <LinhaItemSic>
            <LinhaItemSicSpaceBetween>
              <b>Resposta do Recurso da Retificação:</b>
              <small>
                (Respondido em:
                {' '}
                {dataHoraRespostaRecursoRetificacao}
                )
              </small>
            </LinhaItemSicSpaceBetween>
            <div dangerouslySetInnerHTML={{ __html: respostaRecursoRetificacao }} />
          </LinhaItemSic>
        </>
      )}

      {(retificacao && visivelRetificacao === 'S' && !recursoRetificacao && verificarTempoRecursoRetificacao()) && dadosLogin.data.anonimo === 'naoanonimo' && (
        <>
          <hr />

          <LinhaItemSic>
            <BoldTitulo>Recurso da Retificação:</BoldTitulo>

            <FormControl
              value={values.Recurso}
              onChange={({ target }) => setVal('Recurso', target.value)}
              // onChange={({ target }) => setValues({
              //   ...values,
              //   Recurso: target.value,
              // })}
              type="textarea"
            />

            <ContainerJustifyEnd>
              {carregando !== true ? (
                <Botao
                  label="Enviar"
                  onClick={() => enviarRecurso('RR')}
                />
              ) : (
                <Carregar />
              )}
            </ContainerJustifyEnd>
          </LinhaItemSic>
        </>
      )}

      {(resposta && !recurso && (!retificacao || visivelRetificacao === 'N') && verificarTempoRecursoResposta()) && dadosLogin.data.anonimo === 'naoanonimo' && (
        <>
          <hr />

          <LinhaItemSic>
            <BoldTitulo>Recurso:</BoldTitulo>

            <FormControl
              value={values.Recurso}
              onChange={({ target }) => setVal('Recurso', target.value)}
              // onChange={({ target }) => setValues({
              //   ...values,
              //   Recurso: target.value,
              // })}
              type="textarea"
            />

            <ContainerJustifyEnd>
              {carregando !== true ? (
                <Botao
                  label="Enviar"
                  onClick={() => enviarRecurso('RP')}
                />
              ) : (
                <Carregar />
              )}
            </ContainerJustifyEnd>
          </LinhaItemSic>
        </>
      )}

      {(arquivos && arquivos.length > 0) && (
        <>
          <hr />

          <GridArquivos>
            {arquivos && arquivos.map((arquivo) => {
              if (arquivo.Valor.endsWith('mp3') || arquivo.Valor.endsWith('aac') || arquivo.Valor.endsWith('ogg')) {
                return (
                  <GridBotao
                    key={arquivo.Valor}
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: 'audio/mp3',
                        preview: arquivo.Valor,
                      }));
                    }}
                    img={AudioPng}
                    imgWidth={45}
                    type="arquivo"
                  />
                );
              }
              if (arquivo.Valor.endsWith('mp4') || arquivo.Valor.endsWith('mov')) {
                return (
                  <GridBotao
                    key={arquivo.Valor}
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: 'video/mp4',
                        preview: arquivo.Valor,
                      }));
                    }}
                    img={VideoPng}
                    imgWidth={45}
                    type="arquivo"
                  />
                );
              }
              if (arquivo.Valor.endsWith('pdf')) {
                return (
                  <GridBotao
                    key={arquivo.Valor}
                    onClick={() => {
                      dispatch(abrirModalArquivo());
                      dispatch(selecionarArquivo({
                        type: 'application/pdf',
                        preview: arquivo.Valor,
                      }));
                    }}
                    img={PdfPng}
                    imgWidth={45}
                    type="arquivo"
                  />
                );
              }
              if (arquivo.Valor.endsWith('zip')) {
                return (
                  <GridBotao
                    key={arquivo.Valor}
                    img={ZipPng}
                    imgWidth={45}
                    type="arquivo"
                    onClick={() => {
                      window.location.href = arquivo.Valor;
                    }}
                  />
                );
              }
              if (arquivo.Valor.endsWith('rar')) {
                return (
                  <GridBotao
                    key={arquivo.Valor}
                    img={RarPng}
                    imgWidth={45}
                    type="arquivo"
                    onClick={() => {
                      window.location.href = arquivo.Valor;
                    }}
                  />
                );
              }
              return (
                <GridBotao
                  key={arquivo.Valor}
                  onClick={() => {
                    dispatch(abrirModalArquivo());
                    dispatch(selecionarArquivo({
                      type: 'image/jpeg',
                      preview: arquivo.Valor,
                    }));
                  }}
                  img={arquivo.Valor}
                  type="arquivo"
                />
              );
            })}
          </GridArquivos>
        </>
      )}
    </GridContainerPrincipal>
  );
};

CardSic.propTypes = {
  arquivos: PropTypes.oneOfType([PropTypes.array]),
  id: PropTypes.string,
  assunto: PropTypes.string,
  unidade: PropTypes.string,
  dataHora: PropTypes.string,
  secretaria: PropTypes.string,
  pergunta: PropTypes.string,
  resposta: PropTypes.string,
  frequentes: PropTypes.bool,
  dataHoraResposta: PropTypes.string,
  recurso: PropTypes.string,
  respostaRecurso: PropTypes.string,
  dataHoraRespostaRecurso: PropTypes.string,
  dataHoraAberturaRecurso: PropTypes.string,
  onRefresh: PropTypes.func,
  retificacao: PropTypes.string,
  dataHoraRetificacao: PropTypes.string,
  visivelRetificacao: PropTypes.string,
  recursoRetificacao: PropTypes.string,
  dataHoraAberturaRecursoRetificacao: PropTypes.string,
  dataHoraRespostaRecursoRetificacao: PropTypes.string,
  respostaRecursoRetificacao: PropTypes.string,
};

CardSic.defaultProps = {
  arquivos: '',
  id: '',
  assunto: '',
  unidade: '',
  dataHora: '',
  secretaria: '',
  pergunta: '',
  resposta: '',
  frequentes: false,
  dataHoraResposta: '',
  recurso: '',
  respostaRecurso: '',
  dataHoraRespostaRecurso: '',
  dataHoraAberturaRecurso: '',
  onRefresh: null,
  retificacao: '',
  dataHoraRetificacao: '',
  visivelRetificacao: '',
  recursoRetificacao: '',
  dataHoraAberturaRecursoRetificacao: '',
  dataHoraRespostaRecursoRetificacao: '',
  respostaRecursoRetificacao: '',
};

export default CardSic;
